import React from 'react';
import './select-invoice-checkbox.scss';
import { Invoice } from '@zonofi/zono-money-store';
import { View } from '../../common';
import { SVGS } from '../../assets';

interface SelectInvoiceCheckboxProps {
  invoice: Invoice;
  selectedInvoices: any[];
  onSelectInvoice: (val: string) => void;
}

export const SelectInvoiceCheckbox: React.FC<SelectInvoiceCheckboxProps> = ({
  invoice,
  selectedInvoices,
  onSelectInvoice,
}) => {
  return (
    <View className="invoice-card-select-checkbox">
      <View
        className={`invoice-card-select-checkbox-box ${
          selectedInvoices.includes(invoice?.id) ? 'checked' : ''
        }`}
        onPress={() => onSelectInvoice(invoice?.id)}
      >
        {selectedInvoices.includes(invoice?.id) ? (
          <img src={SVGS.Checked} alt="selected" />
        ) : null}
      </View>
    </View>
  );
};
